import React from "react";
import { ReactComponent as CheckedIcon } from "../../../../img/CheckIcon.svg";
import { ReactComponent as Error } from "../../../../img/Error.svg";
import { ReactComponent as Info } from "../../../../img/InfoIcon.svg";

const NotificationIcon = ({ type }) => {
	switch (type) {
		case "success":
			return <CheckedIcon />;

		case "info":
			return <Info />;

		case "warning":
			return <Error />;

		default:
			return null;
	}
};
export default NotificationIcon;
